export const actionTypes = {
    setModalOpen: 'MODAL_SET_OPEN',
    setModalClose: 'MODAL_SET_CLOSE',
}

export const setModalOpen = () => ({ type: actionTypes.setModalOpen });
export const setModalClose = () => ({ type: actionTypes.setModalClose });